import type { GenerateDynamicPackageHashResponse } from '@ecomm/data-simplisafe-api'
import { COOKIE_RETURN_TO_QW, setCookie } from '@ecomm/shared-cookies'
import type { IdentifyTraits } from '@ecomm/shared-ninetailed'
import {
  brazeTrackGuidedSystemBuilderRecommendation,
  convertQueryParamsToObject,
  generateDynamicPackagePageURL
} from '@ecomm/tracking'
import { cookiesOption } from '@simplisafe/ss-ecomm-data/simplisafe/yodaClient'
import * as O from 'fp-ts/Option'
import { convertParamsObjectToResponsesArray } from '../../utils/guidedSystemBuilder'

export function handleDynamicPackageHashResponse(args: {
  attributeHash: string
  email: string
  name: string | null
  phone: string | null
  searchParams: string
  setDynamicHashResponse: React.Dispatch<
    React.SetStateAction<O.Option<GenerateDynamicPackageHashResponse>>
  >
  identify: (traits: IdentifyTraits) => void
}) {
  const {
    attributeHash,
    email,
    name,
    phone,
    searchParams,
    setDynamicHashResponse,
    identify
  } = args
  setCookie(COOKIE_RETURN_TO_QW, attributeHash, cookiesOption)
  identify({
    email: email,
    ...(name ? { firstName: name } : {}),
    dynamicUrl: 'product/system/' + attributeHash,
    ...(phone ? { phone } : {})
  })
  brazeTrackGuidedSystemBuilderRecommendation(
    generateDynamicPackagePageURL(attributeHash),
    searchParams,
    convertParamsObjectToResponsesArray(
      convertQueryParamsToObject(searchParams)
    )
  )
  setDynamicHashResponse(O.some({ attributeHash }))
}
